import { Doughnut } from "react-chartjs-2";
import {
  ArcElement,
  Chart as ChartJS,
  ChartData,
  Legend,
  Tooltip,
} from "chart.js";
import { useTheme } from "@mui/material";
import { formatCurrency } from "@/utils/formatCurrency.ts";
import { BudgetType } from "@/types";
import { getDonutChartTooltipConfig } from "@/pages/DashboardPage/helpers/utils";

ChartJS.register(ArcElement, Tooltip, Legend);

const chartDataItems = [
  { value: 0, label: "Remaining" },
  { value: 0, label: "Reserved" },
  { value: 0, label: "Paid" },
];

const BudgetChart = ({ widgetData }: { widgetData: BudgetType }) => {
  const { palette } = useTheme();
  const remaining = widgetData?.remainingTotal;
  const reserved = widgetData?.reservedTotal;
  const paid = widgetData?.paidTotal;
  const totalBudget = widgetData?.total;

  const displayPaid = paid;
  const displayReserved = reserved;
  const displayRemaining = remaining;

  const total = totalBudget;

  chartDataItems[0].value = displayRemaining;
  chartDataItems[1].value = displayReserved;
  chartDataItems[2].value = displayPaid;

  const data: ChartData<"doughnut", number[], string> = {
    labels: ["Remaining", "Reserved", "Paid"],
    datasets: [
      {
        data: [displayRemaining, displayReserved, displayPaid],
        backgroundColor: [
          palette.chartFirstColor,
          palette.chartSecondColor,
          palette.chartThirdColor,
        ],
        borderColor: [
          palette.chartFirstColor,
          palette.chartSecondColor,
          palette.chartThirdColor,
        ],
        borderWidth: 1,
        spacing:
          total === displayRemaining ||
          total === displayReserved ||
          total === displayPaid
            ? 0
            : 8,
        borderRadius:
          total === displayRemaining ||
          total === displayReserved ||
          total === displayPaid
            ? 0
            : 4,
      },
    ],
  };

  return (
    <Doughnut
      style={{
        width: "240px",
        maxHeight: "240px",
        minHeight: "240px",
      }}
      data={data}
      options={{
        maintainAspectRatio: false,
        responsive: true,
        layout: {},
        plugins: {
          legend: {
            display: false,
          },
          tooltip: getDonutChartTooltipConfig(
            chartDataItems,
            total,
            "value",
            "label",
            false,
            true
          ),
        },
        cutout: 70,
      }}
    />
  );
};

export default BudgetChart;
